import { useEffect } from "react";
import { useLang, SLUGS } from "@/context/LanguageContext";

export function useSEO(pageKey) {
  const { lang, t } = useLang();
  useEffect(() => {
    const meta = t.seo[pageKey];
    if (!meta) return;
    document.title = meta.title;
    document.documentElement.lang = lang;
    const setMeta = (selector, attr, value) => {
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        const [kind, name] = selector.match(/\[(.+?)="(.+?)"\]/).slice(1, 3);
        el.setAttribute(kind, name);
        document.head.appendChild(el);
      }
      el.setAttribute(attr, value);
    };
    setMeta('meta[name="description"]', "content", meta.desc);
    setMeta('meta[property="og:title"]', "content", meta.title);
    setMeta('meta[property="og:description"]', "content", meta.desc);
    setMeta('meta[property="og:locale"]', "content", lang === "de" ? "de_DE" : "it_IT");
    document.head.querySelectorAll("link[data-hreflang]").forEach((l) => l.remove());
    const origin = window.location.origin;
    ["de", "it"].forEach((l) => {
      const link = document.createElement("link");
      link.rel = "alternate";
      link.hreflang = l;
      link.dataset.hreflang = "1";
      const slug = SLUGS[l][pageKey] ?? "";
      link.href = `${origin}/${l}${slug ? `/${slug}` : ""}`;
      document.head.appendChild(link);
    });
    const xd = document.createElement("link");
    xd.rel = "alternate";
    xd.hreflang = "x-default";
    xd.dataset.hreflang = "1";
    xd.href = `${origin}/de`;
    document.head.appendChild(xd);
  }, [pageKey, lang, t]);
}
